<template>
  <table class="jin-month-table">
    <tbody>
      <tr
        v-for="(row, key) in tableRows"
        :key="key"
      >
        <td v-for="cell in row" :key="cell">
          <div
            :class="{
              'current': cell === month + 1
            }"
            @click="$emit('pick', cell - 1)"
          >
            {{ cell }}月
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
/* eslint-disable vue/require-prop-types */

export default {
  name: 'JinMonthTable',
  props: {
    date: {}
  },
  data () {
    return {
      tableRows: [
        [1, 2, 3, 4, 5, 6],
        [7, 8, 9, 10, 11, 12]
      ]
    }
  },
  computed: {
    month () {
      return this.date.getMonth()
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/helpers/_function.scss";

.jin-month-table {
  margin: 0 auto;
  td {
    cursor: pointer;
    &:hover {
      color: $primary;
    }
    div {
      margin: 0 1px;
      width: 32px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      transition: background .3s;
      color: $primary;
      border-radius: 50%;
      &:hover {
        color: $primary;
      }
      &.current {
        background: $primary;
        color: #fff;
        font-weight: bold;
        &:hover {
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// JinMonthTable.vue?4a083b46